export const masahifSizesWithProducts = [
  [
    {
      size: "17-12",
      ids: [
        {
          id: "6828d0e4d609e283b1916630",
          name: "مصحف ورش تجليد بيو وردي فاتح 17-12 سحاب",
        },
        {
          id: "6828d0c6d609e283b191662a",
          name: "مصحف ورش تجليد بيو وردي 17-12 سحاب",
        },
        {
          id: "6828d0a9d609e283b1916624",
          name: "مصحف ورش تجليد بيو فيروزي 17-12 سحاب",
        },
        {
          id: "6828d08fd609e283b1916620",
          name: "مصحف ورش تجليد بيو ذهبي 17-12 سحاب",
        },
        {
          id: "6828d06ed609e283b191661a",
          name: "مصحف ورش تجليد بيو بني 17-12 سحاب",
        },
        {
          id: "6828d051d609e283b1916616",
          name: "مصحف ورش تجليد بيو بنفسجي 17-12 سحاب",
        },
        {
          id: "6828d02cd609e283b191660a",
          name: "مصحف ورش تجليد بيو أسود 17-12 سحاب",
        },
        {
          id: "6828d011d609e283b1916606",
          name: "مصحف ورش تجليد بيو أزرق 17-12 سحاب",
        },
        {
          id: "6828cff1d609e283b1916600",
          name: "مصحف ورش تجليد بيو أخضر 17-12 سحاب",
        },
        {
          id: "6828cfcfd609e283b19165fc",
          name: "مصحف ورش تجليد بيو أحمر 17-12 سحاب",
        },
        {
          id: "6828cdb8d609e283b19165c8",
          name: "مصحف ورش تجليد بيو أبيض 17-12 سحاب",
        },
        {
          id: "6828cdb7d609e283b19165c4",
          name: "مصحف ورش تجليد بيو وردي فاتح 17-12",
        },
        {
          id: "6828cd96d609e283b19165c0",
          name: "مصحف ورش تجليد بيو وردي 17-12",
        },
        {
          id: "6828cd95d609e283b19165bc",
          name: "مصحف ورش تجليد بيو وردي 17-12",
        },
        {
          id: "6828cd7bd609e283b19165b6",
          name: "مصحف ورش تجليد بيو فيروزي 17-12",
        },
        {
          id: "6828cd60d609e283b19165ae",
          name: "مصحف ورش تجليد بيو ذهبي 17-12",
        },
        {
          id: "6828cd45d609e283b19165a8",
          name: "مصحف ورش تجليد بيو بني 17-12",
        },
        {
          id: "6828cd26d609e283b19165a0",
          name: "مصحف ورش تجليد بيو بنفسجي 17-12",
        },
        {
          id: "6828cd0ed609e283b191659c",
          name: "مصحف ورش تجليد بيو أسود 17-12",
        },
        {
          id: "6828ccf3d609e283b1916593",
          name: "مصحف ورش تجليد بيو أزرق 17-12",
        },
        {
          id: "6828ccd5d609e283b191658f",
          name: "مصحف ورش تجليد بيو أخضر 17-12",
        },
        {
          id: "6828ccbad609e283b1916589",
          name: "مصحف ورش تجليد بيو أحمر 17-12",
        },
        {
          id: "6828cca3d609e283b1916585",
          name: "مصحف ورش تجليد بيو أبيض 17-12",
        },
      ],
    },
    {
      size: "17-24",
      ids: [
        {
          id: "6828cbb4d609e283b191656f",
          name: "مصحف ورش تجليد بيو وردي فاتح 17-24",
        },
        {
          id: "6828cbb3d609e283b191656b",
          name: "مصحف ورش تجليد بيو وردي فاتح 17-24",
        },
        {
          id: "6828cb97d609e283b1916567",
          name: "مصحف ورش تجليد بيو وردي 17-24",
        },
        {
          id: "6828cb7bd609e283b191655d",
          name: "مصحف ورش تجليد بيو فيروزي 17-24",
        },
        {
          id: "6828cb60d609e283b1916555",
          name: "مصحف ورش تجليد بيو ذهبي 17-24",
        },
        {
          id: "6828cb3cd609e283b191654d",
          name: "مصحف ورش تجليد بيو بني 17-24",
        },
        {
          id: "6828cb20d609e283b1916546",
          name: "مصحف ورش تجليد بيو بنفسجي 17-24",
        },
        {
          id: "6828cb03d609e283b1916542",
          name: "مصحف ورش تجليد بيو أسود 17-24",
        },
        {
          id: "6828cae7d609e283b191653c",
          name: "مصحف ورش تجليد بيو أزرق 17-24",
        },
        {
          id: "6828cab6d609e283b1916532",
          name: "مصحف ورش تجليد بيو أخضر 17-24",
        },
        {
          id: "6828ca6fd609e283b1916527",
          name: "مصحف ورش تجليد بيو أحمر 17-24",
        },
        {
          id: "6828ca54d609e283b1916523",
          name: "مصحف ورش تجليد بيو أبيض 17-24",
        },
        {
          id: "68289871d609e283b1915fee",
          name: "مصحف الصدقة الجارية 17-24 (عرض 36 نسخة)",
        },
        {
          id: "6828984ed609e283b1915fe5",
          name: "مصحف الصدقة الجارية 17-24 (عرض 10 نسخة)",
        },
        {
          id: "68288fe4d609e283b1915d36",
          name: "مصحف المدينة ورش عن نافع 17-24",
        },
        {
          id: "68288fc5d609e283b1915d30",
          name: "مصحف أسماء الله الحسنى ورش عن نافع 17-24 ",
        },
        {
          id: "68288ec8d609e283b1915d18",
          name: "مصحف الكعبة الشريفة ورش عن نافع 17-24",
        },
      ],
    },
    {
      size: "14-20",
      ids: [
        {
          id: "6828c66cd609e283b1916481",
          name: "مصحف ورش تجليد بيو وردي فاتح 14-20 سحاب",
        },
        {
          id: "6828c648d609e283b1916477",
          name: "مصحف ورش تجليد بيو وردي 14-20 سحاب",
        },
        {
          id: "6828c62ad609e283b1916471",
          name: "مصحف ورش تجليد بيو فيروزي 14-20 سحاب",
        },
        {
          id: "6828c60ed609e283b191646b",
          name: "مصحف ورش تجليد بيو ذهبي 14-20 سحاب",
        },
        {
          id: "6828c5e7d609e283b1916467",
          name: "مصحف ورش تجليد بيو بني 14-20 سحاب",
        },
        {
          id: "6828c5c5d609e283b1916463",
          name: "مصحف ورش تجليد بيو بنفسجي 14-20 سحاب",
        },
        {
          id: "6828c5aad609e283b191645f",
          name: "مصحف ورش تجليد بيو أسود 14-20 سحاب",
        },
        {
          id: "6828c58cd609e283b191645b",
          name: "مصحف ورش تجليد بيو أزرق 14-20 سحاب",
        },
        {
          id: "6828c568d609e283b1916455",
          name: "مصحف ورش تجليد بيو أخضر 14-20 سحاب",
        },
        {
          id: "6828c546d609e283b191644f",
          name: "مصحف ورش تجليد بيو أحمر 14-20 سحاب",
        },
        {
          id: "6828c52ed609e283b1916447",
          name: "مصحف ورش تجليد بيو أبيض 14-20 سحاب",
        },
        {
          id: "6828c006d609e283b19163e5",
          name: "مصحف ورش تجليد بيو وردي فاتح 14-20",
        },
        {
          id: "6828bfe8d609e283b19163df",
          name: "مصحف ورش تجليد بيو وردي 14-20",
        },
        {
          id: "6828bfc7d609e283b19163db",
          name: "مصحف ورش تجليد بيو فيروزي 14-20",
        },
        {
          id: "6828bfa1d609e283b19163d7",
          name: "مصحف ورش تجليد بيو ذهبي 14-20",
        },
        {
          id: "6828bf83d609e283b19163d3",
          name: "مصحف ورش تجليد بيو بني 14-20",
        },
        {
          id: "6828bf5fd609e283b19163c7",
          name: "مصحف ورش تجليد بيو بنفسجي 14-20",
        },
        {
          id: "6828bf37d609e283b19163c1",
          name: "مصحف ورش تجليد بيو أسود 14-20",
        },
        {
          id: "6828bf1cd609e283b19163bd",
          name: "مصحف ورش تجليد بيو أزرق 14-20",
        },
        {
          id: "6828bef9d609e283b19163b9",
          name: "مصحف ورش تجليد بيو أخضر 14-20",
        },
        {
          id: "6828bed6d609e283b19163b3",
          name: "مصحف ورش تجليد بيو أحمر 14-20",
        },
        {
          id: "6828be9cd609e283b19163af",
          name: "مصحف ورش تجليد بيو أبيض 14-20",
        },
        {
          id: "68261f84d609e283b1910e40",
          name: "(عرض 54 نسخة) مصحف الصدقة الجارية 14-20",
        },
        {
          id: "68261957d609e283b1910e02",
          name: "مصحف المدينة 14-20 ورش عن نافع",
        },
        {
          id: "68261f36d609e283b1910e34",
          name: "(عرض 28 نسخة) مصحف الصدقة الجارية 14-20",
        },
        {
          id: "6828c006d609e283b19163e5",
          name: "مصحف ورش تجليد بيو وردي فاتح 14-20",
        },
        {
          id: "6828bfe8d609e283b19163df",
          name: "مصحف ورش تجليد بيو وردي 14-20",
        },
      ],
    },
    {
      size: "08-12",
      ids: [
        {
          id: "6828c9f8d609e283b191651b",
          name: "مصحف ورش تجليد بيو وردي فاتح 08-12 سحاب",
        },
        {
          id: "6828c9d9d609e283b1916515",
          name: "مصحف ورش تجليد بيو وردي 08-12 سحاب",
        },
        {
          id: "6828c9bad609e283b1916511",
          name: "مصحف ورش تجليد بيو فيروزي 08-12 سحاب",
        },
        {
          id: "6828c99fd609e283b1916503",
          name: "مصحف ورش تجليد بيو ذهبي 08-12 سحاب",
        },
        {
          id: "6828c984d609e283b19164fd",
          name: "مصحف ورش تجليد بيو بني 08-12 سحاب",
        },
        {
          id: "6828c965d609e283b19164f7",
          name: "مصحف ورش تجليد بيو بنفسجي 08-12 سحاب",
        },
        {
          id: "6828c946d609e283b19164f3",
          name: "مصحف ورش تجليد بيو أسود 08-12 سحاب",
        },
        {
          id: "6828c92ad609e283b19164ef",
          name: "مصحف ورش تجليد بيو أزرق 08-12 سحاب",
        },
        {
          id: "6828c90cd609e283b19164eb",
          name: "مصحف ورش تجليد بيو أخضر 08-12 سحاب",
        },
        {
          id: "6828c8f0d609e283b19164e5",
          name: "مصحف ورش تجليد بيو أحمر 08-12 سحاب",
        },
        {
          id: "6828c8d5d609e283b19164e1",
          name: "مصحف ورش تجليد بيو أبيض 08-12 سحاب",
        },
        {
          id: "6828c845d609e283b19164cf",
          name: "مصحف ورش تجليد بيو وردي فاتح 08-12",
        },
        {
          id: "6828c828d609e283b19164c9",
          name: "مصحف ورش تجليد بيو وردي 08-12",
        },
        {
          id: "6828c807d609e283b19164c1",
          name: "مصحف ورش تجليد بيو فيروزي 08-12",
        },
        {
          id: "6828c7ebd609e283b19164bd",
          name: "مصحف ورش تجليد بيو ذهبي 08-12",
        },
        {
          id: "6828c7ced609e283b19164b3",
          name: "مصحف ورش تجليد بيو بني 08-12",
        },
        {
          id: "6828c7a9d609e283b19164a9",
          name: "مصحف ورش تجليد بيو بنفسجي 08-12",
        },
        {
          id: "6828c788d609e283b19164a5",
          name: "مصحف ورش تجليد بيو أسود 08-12",
        },
        {
          id: "6828c768d609e283b19164a1",
          name: "مصحف ورش تجليد بيو أزرق 08-12",
        },
        {
          id: "6828c74bd609e283b191649d",
          name: "مصحف ورش تجليد بيو أخضر 08-12",
        },
        {
          id: "6828c72fd609e283b1916499",
          name: "مصحف ورش تجليد بيو أحمر 08-12",
        },
        {
          id: "6828c710d609e283b1916491",
          name: "مصحف ورش تجليد بيو أبيض 08-12",
        },
      ],
    },
  ],
];
